export default function setLocation(location: any): void {
    window.location = location;
}
